import { ScansList } from 'features/ScansList';
import { PunchupScannedTickets } from 'features/PunchupPages/ScannedTickets';
import { useAppSelector } from 'store/hooks';

const ScansListPage = (): JSX.Element => {
	const { isPunchup, greenZoneEnabled } = useAppSelector((state) => state.auth);
	if (isPunchup && greenZoneEnabled) return <PunchupScannedTickets />;
	return <ScansList />;
};
export default ScansListPage;
